import * as React from 'react';

import { Slug } from '@fnv-core/utils';
import { FormControlProps } from '../interfaces/FormControlProps';
import { FormFieldStateHelpers } from './helpers/FormFieldStateHelpers';
import { FormStylingHelpers } from './helpers/FormStylingHelpers';
import { FormLabelHelpers } from './helpers/FormLabelHelpers';
import { PropertyHelpers } from '../helpers/PropertyHelpers';
import { FormControlHelpers } from './helpers/FormControlHelpers';
import ReactHtmlParser from 'react-html-parser';
import { LabelAndPopover } from './components/label-and-popover';

export interface InputState {
    dataSourceCounter: number;
    timer: any;
    isButtonClicked: boolean;
    isLoading: boolean;
    isErrorLoading : boolean;
    hasFocus: boolean;
}

class Input extends React.Component<FormControlProps, InputState> {
    constructor(props: FormControlProps) {
        super(props);
        this.state = {
            dataSourceCounter: 0,
            timer: undefined,
            isButtonClicked: false,
            isLoading: false,
            isErrorLoading : false,
            hasFocus: false
        };
    }

    componentDidMount = () => {
        const value = this.props.field.value,
            formikBag = this.props.formikBag,
            formFieldDefinition = this.props.formFieldDefinition;
        
        if (value !== '') {
            formikBag.setFieldTouched(formFieldDefinition.name, true, true);
        }
    }

    clickButton = (event) => {
        event.preventDefault();
        if (this.props.formFieldDefinition.buttonMode == "post") {                
            this.props.formController.submitToContainer(this.props.formikBag.values, true , true);
        }
        return false;
    }

    onInputFocus = (event) => {
        this.setState({hasFocus : true});
    }

    onInputBlur = (event) => {
        if (event.persist) {
            event.persist();
        }
        this.setState({hasFocus : false}, () => {
            this.props.field.onBlur(event);
        });
    }

    render() {
        const inputProperties = {
            // Input properties has everything needed to deal with manual input
            // It will load related data when a datasource is set
            ...FormControlHelpers.inputProperties(this)
        };
        const inputDecorators = this.props.formFieldDefinition.inputcontrolstyle !== undefined ? (this.props.formFieldDefinition.inputcontrolstyle || "").toLowerCase().split(" ") : "";
        const hasEuro = inputDecorators.indexOf("euro") >= 0;
        const hasPercentage = inputDecorators.indexOf("percentage") >= 0;
        let hasAppendedIcon = hasPercentage;
        let textAppended = "";
        let textAppendedClass = "";
        if (hasPercentage) {
            textAppended = "%";
            textAppendedClass = "input-indicator-indicator";
        } else 
        if (inputDecorators.indexOf("cm") >= 0) {
            textAppended = "cm";
            textAppendedClass = "input-indicator-text";
            hasAppendedIcon = true;
        } else
        if (inputDecorators.indexOf("kg") >= 0) {
            textAppended = "kg";
            textAppendedClass = "input-indicator-text";
            hasAppendedIcon = true;
        } else
        if (inputDecorators.indexOf("graden") >= 0) {
            textAppended = "graden";
            textAppendedClass = "input-indicator-text";
            hasAppendedIcon = true;
        } else if (!hasEuro && this.props.formFieldDefinition.inputcontrolstyle !== undefined && 
            this.props.formFieldDefinition.inputcontrolstyle != "") {
            textAppended = this.props.formFieldDefinition.inputcontrolstyle;
            textAppendedClass = "input-indicator-text";
            hasAppendedIcon = true;
        }

        let imageGroupClass = "no-gutters";
        if (!!this.props.formFieldDefinition.hasImage) {
            imageGroupClass = "no-gutters d-flex form__section-input--with-image";
        }
        return (
            <>
            <div className={FormStylingHelpers.getFormGroupStyle(this.props) + 
                ' form__section-input ' + Slug.fromString(this.props.formFieldDefinition.name) + "-input-form-group " + imageGroupClass }>
                <div className="col-12 col-sm  form__section-input-col">
                    <LabelAndPopover 
                        fieldId={PropertyHelpers.getFieldID(this.props)} 
                        label={FormLabelHelpers.getFieldLabel(this)}
                        explanation={this.props.formFieldDefinition.explanation}
                        hasPopover={this.props.formFieldDefinition.hasPopover}
                        isLoading={this.state.isLoading}                    
                    ></LabelAndPopover>
                    <div className="input-group">

                        {!!hasEuro ?
                            <div className="input-group-prepend input-group-prepend__icon">
                                <div className="input-group-text">
                                    <span>&euro;</span>
                                </div>
                            </div> : null}
                        <input
                            {...inputProperties}
                            inputMode={!!this.props.formFieldDefinition.hasNumericKeyboard ? "numeric" : "text"}
                            autoComplete={!!this.props.formFieldDefinition.disableAutoComplete ? "off" : 
                                this.props.formFieldDefinition.autoCompleteToken !== undefined ? this.props.formFieldDefinition.autoCompleteToken : ""}
                            maxLength={PropertyHelpers.getMaxLength(this.props, 250)}
                            type="text"
                            onFocus={this.onInputFocus}
                            onBlur={this.onInputBlur}
                            className={FormStylingHelpers.getInputStyle(this) + (!!hasAppendedIcon ? " form-control--with-appended-icon" : "") + " " +
                                (!!this.state.hasFocus ? "has-focus" : "")}
                        />                    
                        {!!hasAppendedIcon ?
                            <div className="input-group-append input-group-append__icon">
                                <div className={"input-group-text " + textAppendedClass}>
                                    <span>{textAppended}</span>
                                </div>
                            </div> : null}
                        <div className={"input-group-append form-control--is-valid-indicator" + (!!hasAppendedIcon ? " input-group-append--after-icon" : "")}>
                            <div className="input-group-text">
                                <span className="icon icon-checkmark" />
                            </div>
                        </div>    
                        {!!this.props.formFieldDefinition.hasButton && <div className="input-group-append input-group-append__button">
                                <button 
                                    onClick={this.clickButton}
                                    disabled={this.state.isButtonClicked || FormControlHelpers.isInValid(this) || inputProperties.value == ""}                            
                                    className={"btn btn-primary " + 
                                        ((this.state.isButtonClicked || FormControlHelpers.isInValid(this)) ? "btn-disabled " : "")}>{this.props.formFieldDefinition.buttonLabel}</button>
                            </div>}                                            
                    </div>
                    {!this.state.hasFocus && FormControlHelpers.invalidFeedbackComponent(this)}
                    {this.props.formFieldDefinition.hasPopover === undefined && 
                    this.props.formFieldDefinition.explanation && 
                        this.props.formFieldDefinition.explanation !== "" ? <span className="form-control-plaintext-explanation">{ReactHtmlParser(this.props.formFieldDefinition.explanation)}</span> : null}
                </div>
                {!!this.props.formFieldDefinition.hasImage && <img className="input-group__image-after" src={this.props.formFieldDefinition.imageUrl} alt=""></img>}
            </div>
            <div className={ Slug.fromString(this.props.formFieldDefinition.name) + "-input-form-group-after" + " form-group-after "}></div>
            </>
        );
    }
}

export { Input };
